export { ClickOutsideDirective } from './click-outside.directive';
export { ClickOutsideModule } from './click-outside.module';